// Aligns with FundPerformanceAttribute numericality:
// blank clears the attr; otherwise must be a finite number.
export const PERFORMANCE_VALUE_ERROR = 'must be a number without a percent sign (e.g. 8.56 or -1.60)';

export function isValidPerformanceValue(value) {
  if (value == null || String(value).trim() === '') {
    return true;
  }
  return Number.isFinite(Number(value));
}

export function performanceValidationErrors(performance = []) {
  const hasInvalid = performance.some(attr => !isValidPerformanceValue(attr.value));
  if (!hasInvalid) {
    return null;
  }
  return { value: [PERFORMANCE_VALUE_ERROR] };
}
